/**
 * @generated SignedSource<<22fa4c8a3c5d10ce543001c890055d1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseSocialIcons_photo$data = {
  readonly designFirm: {
    readonly name: string | null;
  } | null;
  readonly id: string;
  readonly path: string | null;
  readonly photoLike: {
    readonly totalPhotoLikes: number | null;
  } | null;
  readonly project: {
    readonly name: string | null;
    readonly url: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly url: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_searchBrowsePhoto">;
  readonly " $fragmentType": "PhotosSearchBrowseSocialIcons_photo";
};
export type PhotosSearchBrowseSocialIcons_photo$key = {
  readonly " $data"?: PhotosSearchBrowseSocialIcons_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseSocialIcons_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseSocialIcons_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhotoProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoLike",
      "kind": "LinkedField",
      "name": "photoLike",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPhotoLikes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getShoppablePhotoData_searchBrowsePhoto",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoTag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getShoppablePhotoData_tags",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SimilarItemsResults",
                  "kind": "LinkedField",
                  "name": "similarItems",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Item",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoCreator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getShoppablePhotoData_creators",
              "selections": [
                {
                  "alias": "photoCreatorItems",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 4
                    }
                  ],
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": (v3/*: any*/),
                  "storageKey": "items(first:4)"
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "55cd9aa6dbdbd6a416373595c1180339";

export default node;
